import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import fa from "./locales/Fa/translation.json";
import en from "./locales/En/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fa: { translation: fa }, en: { translation: en } },
    fallbackLng: "fa",
    supportedLngs: ["fa", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["path", "htmlTag"],
      lookupFromPathIndex: 0,
      caches: [],
    },
    react: { useSuspense: false },
  });

export default i18n;
